import React from "react";
import { LoadingIcon } from "../../../components/Icon/Icon";

export function SubscribeContinueBlackButton({
  loading,
  disabled,
  hexColor,
  children,
  className,
  ...rest
}: { loading?: boolean; hexColor?: string; disabled?: boolean; className?: string } & Omit<
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  "ref"
>) {
  return (
    <>
      <button
        className={`${
          disabled ? "cursor-not-allowed" : ""
        } relative text-white rounded-lg h-14 w-full text-lg font-medium flex flex-row justify-center items-center ${
          className ? className : ""
        }`}
        {...rest}
        style={{ backgroundColor: hexColor || "black" }}
        disabled={disabled}
      >
        {loading ? (
          <div
            style={{
              height: "22px",
              width: "22px",
              position: "absolute",
              left: "50%",
              marginLeft: "-10px",
            }}
          >
            <LoadingIcon />
          </div>
        ) : (
          children
        )}
      </button>
    </>
  );
}
